<template>
  <div>
    <div class="over-lay" @click="closePopup"></div>
    <div class="popup">
      <Positive-Vote class="positive-vote" />
      <div v-if="isG2" class="hdr">Running out of credits?</div>
      <div v-if="inputFeedbackSection" class="hdr">Help us understand!</div>
      <div v-if="isG2" class="dis-content">
        <div class="thanks-section">
          Thanks for being a power user of Adapt. As a sign of appreciation, we
          are offering 50 free credits for every review at
          {{ isCapterraReview ? ' Capterra' : ' G2 Crowd' }}.
        </div>
        <div class="note-section">
          <b>Note:</b> Do share the screenshot of your
          {{ isCapterraReview ? ' Capterra' : ' G2 Crowd' }} review with
          <a>success@adapt.io</a> to claim free credits
        </div>
      </div>
      <div v-else class="dis-content">
        <div
          v-if="showReviewStep1 && !showReviewStep2 && !showFeedbackSection"
          class="thanks-section title-msg"
        >
          Do you find Adapt Prospector helpful?
        </div>
        <div
          v-if="!showReviewStep1 && showReviewStep2 && !showFeedbackSection"
          class="thanks-section title-msg"
        >
          How about a rating on the chrome store, then?
        </div>
        <div
          v-if="!showReviewStep1 && !showReviewStep2 && showFeedbackSection"
          class="thanks-section title-msg"
        >
          No worries. Can you share any improvements that you would like to see
          on the Adapt Prospector?
        </div>
        <div
          v-if="inputFeedbackSection"
          contenteditable="true"
          class="feedback-hldr"
          id="_feedback_form"
        ></div>
      </div>
      <div class="btn-section d-flex">
        <span v-if="showReviewStep1 && !isG2 && !inputFeedbackSection">
          <V-Button
            :className="'btn-blue'"
            :text="'Yes'"
            :loading="false"
            :callback="redirectToReviewStep2"
          ></V-Button>
          <V-Button
            :className="'btn-blue'"
            :text="'No'"
            :loading="false"
            :callback="showReviewFeedback"
          ></V-Button>
        </span>
        <span v-else>
          <V-Button
            v-if="showFeedbackSection && !inputFeedbackSection"
            :className="'btn-blue'"
            :text="'Ok, Sure'"
            :loading="false"
            :callback="showInputFeedbackSection"
          ></V-Button>
          <V-Button
            v-if="!showFeedbackSection && !inputFeedbackSection"
            :className="'btn-blue'"
            :text="'Ok, Sure'"
            :loading="false"
            :callback="reviewBtnClick"
          ></V-Button>
          <V-Button
            v-if="!inputFeedbackSection"
            :className="'cancelBtn'"
            :callback="noReview"
            :text="'No, Thanks'"
            :loading="false"
          ></V-Button>
        </span>
        <span v-if="inputFeedbackSection">
          <V-Button
            :className="'btn-blue'"
            :text="'Submit'"
            :loading="false"
            :callback="saveUserFeedback"
          ></V-Button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import positiveVoteIcon from '@/assets/icons/svg/positive-vote.svg'
import button from '@/components/Button'
import sharedFunctions from '@/assets/util/functions.js'
import {
  MX_REVIEW_SECTION_SHOWED,
  MX_REVIEW_NO_CLICKED,
  MX_REVIEW_2_YES_CLICKED,
  MX_FEEDBACK_MSG_GIVEN,
} from '@/assets/util/constants/analytics.js'
import { setCookie } from '@/assets/util/commonUtil'
import { G2_REVIEW_LINK } from '@/assets/util/constants/constants.js'

export default {
  name: 'Add-Domain-Find-Email',
  props: ['text', 'data'],
  data: function () {
    return {
      showPopup: false,
      domain: '',
      companyName: '',
      isG2: true,
      isCapterraReview: false,
      showFeedbackSection: false,
      showReviewStep1: true,
      showReviewStep2: false,
      isFeedbackSection: false,
      inputFeedbackSection: false,
    }
  },

  components: {
    'V-Button': button,
    'Positive-Vote': positiveVoteIcon,
  },
  methods: {
    saveUserFeedback() {
      const c = document.querySelector('#_feedback_form')
      if (c) {
        let text = c.innerText
        sharedFunctions.track(
          MX_FEEDBACK_MSG_GIVEN,
          { isG2: this.isG2, isCapterraReview: this.isCapterraReview, text },
          this.$store.state
        )
        this.closePopup()
      }
    },
    showInputFeedbackSection() {
      this.showFeedbackSection = false
      this.showReviewStep2 = false
      this.showReviewStep1 = false
      this.inputFeedbackSection = true
      setTimeout(function () {
        const c = document.querySelector('#_feedback_form')
        if (c) {
          c.focus()
        }
      }, 500)
    },
    showReviewFeedback() {
      this.showFeedbackSection = true
      this.showReviewStep2 = false
      this.showReviewStep1 = false
    },
    redirectToReviewStep2() {
      this.showReviewStep1 = false
      this.showReviewStep2 = true
    },
    closePopup() {
      this.$emit('reviewPopupClosed', true)
    },
    noReview() {
      sharedFunctions.track(
        MX_REVIEW_NO_CLICKED,
        { isG2: this.isG2, isCapterraReview: this.isCapterraReview },
        this.$store.state
      )
      this.closePopup()
    },
    reviewBtnClick() {
      sharedFunctions.track(
        MX_REVIEW_2_YES_CLICKED,
        { isG2: this.isG2, isCapterraReview: this.isCapterraReview },
        this.$store.state
      )
      setCookie('review_clicked', true, 180)
      if (this.isG2) {
        if (this.isCapterraReview) {
          window.open('https://www.capterra.com/p/178759/Adapt/reviews/')
        } else {
          window.open(G2_REVIEW_LINK)
        }
      } else {
        if (this.isMainProspector()) {
          window.open(
            'https://chrome.google.com/webstore/detail/linkedin-email-finder-ada/abpjeombpodcafecdidejijglognakhe/reviews?hl=en-US'
          )
        } else {
          window.open(
            'https://chrome.google.com/webstore/detail/adapt-find-emails-on-webs/lbhigcppinlecjbkgkaapkfekijdndaj/reviews?hl=en-US'
          )
        }
      }

      this.$emit('reviewPopupClosed', true)
    },
    isMainProspector() {
      const extId = 'abpjeombpodcafecdidejijglogn'
      const installedExtId = localStorage.getItem('_EXT_ID_')
      if (installedExtId == null || installedExtId.indexOf(extId) != -1) {
        return true
      }
    },
    emailsFound() {
      return localStorage.getItem('emails_found')
    },
  },
  created() {
    // G2 and chrome store review 50-50
    // this.isG2 = new Date().getTime() % 2 == 0

    // Capterra Review
    // if (this.emailsFound() == 5 || this.emailsFound() % 20 == 0) {
    //   if (localStorage.getItem('review_clicked') != 'true') {
    //     this.isCapterraReview = true
    //   }
    // }
    sharedFunctions.track(
      MX_REVIEW_SECTION_SHOWED,
      { isG2: this.isG2, isCapterraReview: this.isCapterraReview },
      this.$store.state
    )
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.over-lay {
  background: rgb(0, 0, 0, 0.85);
  position: fixed;
  height: 100%;
  top: 0px;
  width: 100%;
  left: 0;
  z-index: 3;
}
.popup {
  position: fixed;
  width: 82%;
  color: #474542;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 23px 0;
  border-radius: 5px;
  background-color: $white;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 60px;
  .positive-vote {
    width: 60px;
    height: 60px;
    position: absolute;
    top: -35px;
  }
  .hdr {
    font-size: 20px;
    text-align: center;
    font-weight: 500;
    line-height: 0.84;
  }
  .title-msg {
    font-size: 15px !important;
    margin-top: 0 !important;
    line-height: 1.5 !important;
  }
  .feedback-hldr {
    outline: none;
    max-height: 100px;
    width: 78%;
    border: 1px solid #cecece;
    margin-bottom: 10px;
    margin-top: 10px;
    padding: 8px;
    font-size: 12px;
    overflow-y: auto;
    height: 100px;
  }
  .thanks-section,
  .note-section {
    width: 80%;
    text-align: center;
    line-height: 1.25;
    font-size: 13px;
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .note-section {
    width: 100%;
    padding: 10px 15%;
    margin-bottom: 17px;

    opacity: 0.85;
    font-size: 12px;
    line-height: 1.53;
    color: $text-dark;
    background-color: #f7f7f7;
    a {
      color: $primary-color;
    }
  }
  .btn-section::v-deep {
    flex-direction: column;
    button {
      width: 160px;
      padding: 8px 0px;
      margin: 5px;
      font-size: 14px;
      border: solid 1px #56a2f9;
      border-radius: 5px;
      background-color: $white;
    }
    button.btn-blue {
      background-color: $primary-color;
      color: $white;
    }
    .cancelBtn {
      color: $primary-color;
    }
  }
  .dis-content {
    display: contents;
    font-size: 20px;
  }
}
</style>
